import { connect } from 'react-redux';
import { deleteById, Entities, fetchAll, getEntities, patch, search } from 'src/common';
import AdminOperatorSupportBillingAdministration from 'src/components/admin/operator-support-billing/admin-operator-support-billing-administration';
import { addErrorNotification, addNotification } from 'src/actions/notifications';

const mapStateToProps = state => {
    return {
        busCompanies: getEntities(state, Entities.BUS_COMPANY),
        operatorSupportBillingItems: getEntities(state, Entities.OPERATOR_SUPPORT_BILLING),
    };
};

const AdminOperatorSupportBillingContainer = connect(mapStateToProps, {
    fetchAll,
    patch,
    search,
    deleteById,
    addErrorNotification,
    addNotification,
})(AdminOperatorSupportBillingAdministration);

export default AdminOperatorSupportBillingContainer;
